import { SVG } from "./svg";
import { div, anchor, span } from "./dom";

export interface MenuDom {
  button: Element;
  options: HTMLElement;
  options_wrapper: HTMLElement,
  container: HTMLElement;
}

export class Menu {

  static menu_open = false;

  static menu(close_cb?: Function): MenuDom {
    const contain = div("menu", "no-selection", "flex");
    const wrap = div("dropdown-options-wrapper");
    wrap.tabIndex = -1;
    wrap.style.display = "none";

    wrap.onblur = function () {
      wrap.style.display = "none";
      window.setTimeout(function () {
        wrap.removeAttribute("visible");
      }, 150);
      if (close_cb) {
        close_cb();
      }
      Menu.menu_open = false;
    };
    wrap.onclick = function (e) {
      e.stopPropagation();
      return false;
    }

    const dots = SVG.dots();

    contain.appendChild(dots);

    const opts = div("dropdown-options");
    wrap.appendChild(opts);
    contain.appendChild(wrap);

    const menu = {
      button: dots,
      container: contain,
      options: opts,
      options_wrapper: wrap,
    }

    dots.onmousedown = function (e) {
      e.stopPropagation();
    }

    dots.onclick = function (e) {
      e.stopPropagation();
      Menu.show(menu);
    }

    wrap.onkeydown = function (e) {
      if (e.keyCode == 27) { // esc
        wrap.blur();
      }
    }

    return menu;
  }

  static show(menu: MenuDom) {
    if (menu.options_wrapper.getAttribute("visible") === "true") {
      return;
    }
    menu.options_wrapper.style.display = "block";
    menu.options_wrapper.setAttribute("visible", "true");
    menu.options_wrapper.focus();
    Menu.menu_open = false;
  }

  static add_menu_header(menu: MenuDom, title: string, sub: string) {
    const d = div("menu-head");
    d.innerText = title;
    const s = div("menu-head-sub");
    s.innerText = sub;
    d.appendChild(s);
    menu.options.appendChild(d);
  }

  static add_menu_item(menu: MenuDom, label: string, cb: Function, shortcut?: string) {
    const a = anchor();
    a.innerText = label;
    if (shortcut !== undefined) {
      const s = span("shortcut");
      s.innerText = shortcut;
      a.appendChild(s);
    }
    a.onmousedown = function (e) {
      e.stopPropagation();
    }
    a.onclick = function (e) {
      menu.options_wrapper.blur();
      cb();
      e.stopPropagation();
      return false;
    }
    menu.options.appendChild(a);
  }

  static add_menu_divider(menu: MenuDom) {
    const hr = document.createElement("hr");
    menu.options.appendChild(hr);
  }
}